export const SCOPE = 'catalog';
